import { createContext, useContext, useEffect, useState } from "react";

interface ChromeContextValue {
  hidden: boolean;
  setHidden: (hidden: boolean) => void;
}

export const ChromeContext = createContext<ChromeContextValue>({
  hidden: false,
  setHidden: () => {},
});

export function useChrome() {
  return useContext(ChromeContext);
}

export function useChromeState(): ChromeContextValue {
  const [hidden, setHidden] = useState(false);
  return { hidden, setHidden };
}

/** Call from a full-screen view (builder canvas, wizard) to hide the app shell while mounted. */
export function useHideChrome(shouldHide: boolean) {
  const { setHidden } = useChrome();
  useEffect(() => {
    if (!shouldHide) return;
    setHidden(true);
    return () => setHidden(false);
  }, [shouldHide, setHidden]);
}
